module["exports"] = [
  "Øvre",
  "Nedre",
  "Søndre",
  "Gamle",
  "Østre",
  "Vestre"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nb_NO/address/street_prefix.js
// module id = 3223
// module chunks = 1610